import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { ChannelDetailDataObject } from 'models/service';

export const getChannelDetail = async (channelId: string) =>
  apiClient.get<ChannelDetailDataObject, ApiClientResponse<ChannelDetailDataObject>>(
    routes.channels.detail.get(channelId),
  );
